__turbopack_context__.v({
  "activities_slider": "RidesAndActivities-module-scss-module__lBAMxq__activities_slider",
  "activity_child": "RidesAndActivities-module-scss-module__lBAMxq__activity_child",
  "activity_type_container": "RidesAndActivities-module-scss-module__lBAMxq__activity_type_container",
  "activity_type_img": "RidesAndActivities-module-scss-module__lBAMxq__activity_type_img",
  "activity_type_parent": "RidesAndActivities-module-scss-module__lBAMxq__activity_type_parent",
  "activity_video": "RidesAndActivities-module-scss-module__lBAMxq__activity_video",
  "all_attractions": "RidesAndActivities-module-scss-module__lBAMxq__all_attractions",
  "all_blogs": "RidesAndActivities-module-scss-module__lBAMxq__all_blogs",
  "all_stores": "RidesAndActivities-module-scss-module__lBAMxq__all_stores",
  "attraction_child": "RidesAndActivities-module-scss-module__lBAMxq__attraction_child",
  "blog_child": "RidesAndActivities-module-scss-module__lBAMxq__blog_child",
  "bottom_sec": "RidesAndActivities-module-scss-module__lBAMxq__bottom_sec",
  "buy_ticket_btn": "RidesAndActivities-module-scss-module__lBAMxq__buy_ticket_btn",
  "common_btn_parent": "RidesAndActivities-module-scss-module__lBAMxq__common_btn_parent",
  "highlights": "RidesAndActivities-module-scss-module__lBAMxq__highlights",
  "image_wrapper": "RidesAndActivities-module-scss-module__lBAMxq__image_wrapper",
  "popup_align": "RidesAndActivities-module-scss-module__lBAMxq__popup_align",
  "popup_bg": "RidesAndActivities-module-scss-module__lBAMxq__popup_bg",
  "popup_content": "RidesAndActivities-module-scss-module__lBAMxq__popup_content",
  "restasurant_main": "RidesAndActivities-module-scss-module__lBAMxq__restasurant_main",
  "restaurant_sec": "RidesAndActivities-module-scss-module__lBAMxq__restaurant_sec",
  "restaurnat_left": "RidesAndActivities-module-scss-module__lBAMxq__restaurnat_left",
  "restaurnat_right": "RidesAndActivities-module-scss-module__lBAMxq__restaurnat_right",
  "shimmer": "RidesAndActivities-module-scss-module__lBAMxq__shimmer",
  "similar_attraction": "RidesAndActivities-module-scss-module__lBAMxq__similar_attraction",
  "single_attraction": "RidesAndActivities-module-scss-module__lBAMxq__single_attraction",
  "single_attraction_content": "RidesAndActivities-module-scss-module__lBAMxq__single_attraction_content",
  "single_attraction_video": "RidesAndActivities-module-scss-module__lBAMxq__single_attraction_video",
  "skeleton": "RidesAndActivities-module-scss-module__lBAMxq__skeleton",
  "skeleton_btn": "RidesAndActivities-module-scss-module__lBAMxq__skeleton_btn",
  "skeleton_heading": "RidesAndActivities-module-scss-module__lBAMxq__skeleton_heading",
  "skeleton_image_wrapper": "RidesAndActivities-module-scss-module__lBAMxq__skeleton_image_wrapper",
  "skeleton_title": "RidesAndActivities-module-scss-module__lBAMxq__skeleton_title",
  "skelton_btn_parent": "RidesAndActivities-module-scss-module__lBAMxq__skelton_btn_parent",
  "store_child": "RidesAndActivities-module-scss-module__lBAMxq__store_child",
  "top_sec": "RidesAndActivities-module-scss-module__lBAMxq__top_sec",
});
